<template>
  <v-app>
    <v-content>
      <div class="text-center">
          <v-progress-circular
            :rotate="90"
            :size="300"
            :value="value"
            :width="4"
            :indeterminate="indeterminate"
            color="#16336e"
          >
           <b> {{info}}</b>
          </v-progress-circular>
      </div>
    </v-content>
  </v-app>
</template>

<script>
// import Vuelidate from 'vuelidate'
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, maxLength, email } from 'vuelidate/lib/validators';
import { AUTH_URL } from '../../vars';

export default {
  name: 'App',
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(10) },
    email: { required, email },
    select: { required },
    checkbox: {
      checked(val) {
        return val;
      },
    },
  },
  components: {
  },
  data: () => ({
    value: 0,
    indeterminate: true,
    verify_data: {},
    info: 'Загрузка данных ...',

  }),
  mounted() {
    ///////+
    axios
      .post(`${AUTH_URL}verify-registration/`, this.$route.query)
      .then((result) => {
        this.info = result.data.detail;
        this.value = 100;
        this.indeterminate = false;
        setTimeout(() => {
          this.$router.push('/login');
        }, 30);
      })
      .catch(function (e) {
        this.$toasted.show(`Произошла ошибка: ${e}`, { type: 'error', duration: 3000 });
      });
      ///////+
  }
};
</script>
